// We import flat-map manually because of a client using Edge 17.
// Normally, these polyfills are generated automatically based on
// browserslist, but since we do not want to import all missing
// features of Edge 17 (plus it creates some other compilation issues
// with RegExp), we do it manually.
import { UIRouterUpgradeModule } from "@uirouter/angular-hybrid";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule, registerLocaleData } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import en from "@angular/common/locales/en";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { UpgradeModule } from "@angular/upgrade/static";
import "core-js/modules/es.array.flat-map.js";

/** config ng-zorro-antd i18n **/
import { NZ_I18N, en_US } from "ng-zorro-antd/i18n";
import { NzIconModule } from "ng-zorro-antd/icon";
import app from "@gtmhub/gtmhub";
import { resolveLanguage } from "@gtmhub/localization";
import "@gtmhub/localization/locale/en-us";
import "@gtmhub/shared/smartbanner";
import states from "@gtmhub/states";
import { PermissionsModule } from "@webapp/permissions/permissions.module";
import { SharedModule } from "@webapp/shared/shared.module";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";
import { UiNotificationService } from "@webapp/ui/notification/services/notification.service";
import { UiModule } from "@webapp/ui/ui.module";
import { UsersModule } from "@webapp/users/users.module";
import { icons } from "../icons";
import { AccountsModule } from "./accounts/accounts.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ConfigurationModule } from "./configuration/configuration.module";
import { CoreModule } from "./core/core.module";
import { FavoritesModule } from "./favorites/favorites.module";
import { LinksModule } from "./links/links.module";
import { NavigationModule } from "./navigation/navigation.module";
import { NotificationModule } from "./notification/notification.module";
import { DocumentExporterProvider } from "./pdf-export/providers/pdf-export.providers";
import { ReflectionsModule } from "./reflections/reflections.module";
import { RolesModule } from "./roles/roles.module";
import { TagsModule } from "./tags/tags.module";
import { TeamsModule } from "./teams/teams.module";

registerLocaleData(en);

@NgModule({
  imports: [
    FormsModule,
    BrowserModule,
    HttpClientModule,
    NoopAnimationsModule,
    CoreModule,
    UpgradeModule,
    NavigationModule,
    LinksModule,
    ConfigurationModule,
    RolesModule,
    PermissionsModule,
    TagsModule,
    TeamsModule,
    FavoritesModule,
    AccountsModule,
    // Provides the @uirouter/angular directives and registers
    // the future state for the lazy loaded contacts module
    UIRouterUpgradeModule,
    AppRoutingModule,
    UiModule.forRoot(),
    SharedModule,
    OverlayModule,
    CommonModule,
    NotificationModule,
    UsersModule,
    ReflectionsModule,
    NzIconModule.forRoot(icons),
  ],
  declarations: [AppComponent],
  providers: [{ provide: NZ_I18N, useValue: en_US }, UiModalService, UiNotificationService, DocumentExporterProvider],
})
export class AppModule {
  constructor(private upgrade: UpgradeModule) {}

  public ngDoBootstrap(): void {
    const appConfig = webappConfig();
    if (appConfig.cdnStorage.enabled) {
      __webpack_public_path__ = appConfig.cdnStorage.url + "/dist/";
    }

    const [htmlLang, setLocale] = resolveLanguage();

    document.documentElement.setAttribute("lang", htmlLang);

    setLocale();

    this.doFinalBootstrapping();
  }

  public doFinalBootstrapping(): void {
    // eslint-disable-next-line no-console
    console.log("\n   o   \n   |-o\n o-|\n   |-o\n   o\n\nFind out why we care\n-> https://gtmhub.com/careers\n\n");

    this.upgrade.bootstrap(document.body, [app.name, states], { strictDi: true });
  }
}
